<template>
<v-card
    max-width="374"
    style="margin-left: auto; margin-right: auto; margin-bottom: 15px;"
>

<v-img
    :src="require('@/assets/platypus/' + hero_src)"
></v-img>


<div
    style="text-align: center; width: 100%; margin-top: 15px;"
>
    <img
        :src="require('@/assets/platypus/' + logo_src)"
        style="max-width: 300px"
    />
</div>

<v-card-text>
    <div>{{tagline}}</div>
</v-card-text>
<v-divider/>
<v-card-actions>
    <v-btn
    color="deep-purple lighten-2"
    text
    @click="onClickNotImplemented"
    >
    Website
    </v-btn>
    <v-btn
    color="#5C215F"
    text
    @click="onClickNotImplemented"
    >
    Message
    </v-btn>

</v-card-actions>
</v-card>
</template>

<script>
export default {
    props: {
        hero_src: {
            type: String,
            default: function() { return ""; }
        },

        logo_src: {
            type: String,
            default: function() { return ""; }
        },

        tagline: {
            type: String,
            default: function() { return ""; }
        },
    },

    methods: {
        onClickNotImplemented() {
            this.$rc.snackbar('For Demonstration Purposes Only - Not Implemented');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>